import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { BaseFormComponent } from '../../base-form.component';
import { CommonFunctions } from 'src/app/shared/common/common-functions';

@Component({
  selector: 'app-title-field',
  templateUrl: './title-field.component.html',
  styles: [],
  standalone: false,
})
export class TitleFieldComponent extends BaseFormComponent {

  constructor(private commonFunctions: CommonFunctions) {
    super(commonFunctions);
  }

}
